import { useLayoutElementsResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/useLayoutElementsResponse";
export var useIsLayoutElementsError = function() {
    return useLayoutElementsResponse().isError;
};
